import React from 'react';
import { useHistory } from 'react-router';
import lodash from 'lodash';
import {
  parseQueryString, appStorage
} from '../../../utils/utils';
import useTranslation from '../../../hooks/use-translation';
import './ShowButton.css';
import config from '../../../config.json';
import { ess } from '../../OnBoarding/ess';

import Articles from '../Articles/index';

function callbackToMyJio(data) {
  try {
    if (window.android && window.android.__externalCall) {
      window.android.__externalCall(data);
    }
    if (window.__externalCall) {
      window.__externalCall(data);
    }
    window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callback && window.webkit.messageHandlers.callback.postMessage(data);
  } catch (e) {
    console.log('JS Bridge invoke failed.');
  }
}

const handleMyJioButtonClick = () =>
  callbackToMyJio(
    btoa(unescape(encodeURIComponent(
      JSON.stringify({
        "type": "jhhSymptomsChecker",
        "value": "symptoms_checker"
      })
    )))
  );

const JhhWebAppDoneButtonClickHandler = () => {
  window.parent.postMessage("data", "*");
  const urlParams = new URLSearchParams(window.location.search);
  const redirectUrl = urlParams.get('redirectTo');
  if (redirectUrl) {
    window.location.replace(redirectUrl);
  }
}

const isPnp = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const isPnpParam = urlParams.get("pnp");
  return isPnpParam === "true"
}

const ShowButton = ({ sourceId, severity, children }) => {

  const { t } = useTranslation();
  const params = parseQueryString();
  const history = useHistory();
  const cp_refresh = params.cp_refresh;
  const urlParams = new URLSearchParams(window.location.search);

  // let showUploadCertiButton;
  // if (params.upload_certi == "true") {
  //   if (params.source_id == "JioHealthHub") {
  //     showUploadCertiButton = { showButton: true, buttonLink: config.uploadVaccinationCertificateDeepLink }
  //   }
  //   else if (params.source_id == "emp_xp" && lodash.get(params, "auth_token")
  //     && lodash.get(params, "source_id")
  //     && lodash.get(params, "source_user_id")
  //     && lodash.get(params, "source_relation")
  //     && (lodash.get(params, "source_user_relation_id") !== undefined)
  //     && lodash.get(params, "t")) {
  //     showUploadCertiButton = { showButton: true, buttonLink: `${config.upload_vaccination_certi_link}?auth_token=${encodeURIComponent(lodash.get(params, "auth_token"))}&source_id=${lodash.get(params, "source_id")}&source_user_id=${encodeURIComponent(lodash.get(params, "source_user_id"))}&t=${encodeURIComponent(lodash.get(params, "t"))}&source_relation=${lodash.get(params, "source_relation")}&source_user_relation_id=${lodash.get(params, "source_user_relation_id")}` }
  //   }
  //   else {
  //     console.log(lodash.get(params, "auth_token")
  //       , lodash.get(params, "source_user_id")
  //       , lodash.get(params, "source_id")
  //       , lodash.get(params, "source_relation")
  //       , (lodash.get(params, "source_user_relation_id") !== undefined), lodash.get(params, "source_user_relation_id")
  //       , lodash.get(params, "t"))
  //     showUploadCertiButton = { showButton: false }
  //   }
  // } else {
  //   showUploadCertiButton = { showButton: false }
  // }


  if (sourceId === "JioHealthHub") {
    if (cp_refresh) {
      const user_id = appStorage.getItem('covid_source_user_id');
      return (
        <>
          {children}
          <a href={`${config.refreshPassLink}?user_id=${user_id}`}>
            <button className="buttonList marginLeft20 marginTop20" style={{ background: '#034ea1' }}>{t('REFRESH_PASS') || "Refresh Pass"}</button>
          </a>
        </>
      )
    }

    else if (severity && severity !== "low")
      return (
        <>
          {children}
          <a href={config.consultDocLink}>
            <button className="buttonList marginLeft20 marginTop20" style={{ background: '#034ea1' }}>{t('CONSULT_A_DOCTOR')}</button>
          </a>
          {/* { showUploadCertiButton.showButton &&
            <a href={showUploadCertiButton.buttonLink}>
              <button className="buttonList marginLeft20 marginTop20" style={{ background: '#034ea1' }}>{t('UPLOAD_CERTIFICATE')}</button>
            </a>
          } */}
        </>
      )

    else
      return (<>
        {children}
        <a href={isPnp() ? void (0) : config.dashBoardLink}>
          <button
            className="buttonList marginLeft20 marginTop20"
            onClick={(e) => { window.parent.postMessage("data", "*") }}
            style={{ background: '#034ea1' }}
          >
            {t('DONE')}
          </button>
        </a>
        {/* { showUploadCertiButton.showButton &&
          <a href={showUploadCertiButton.buttonLink}>
            <button className="buttonList marginLeft20 marginTop20" style={{ background: '#034ea1' }}>{t('UPLOAD_CERTIFICATE')}</button>
          </a>
        } */}
      </>)
  }
  else if (sourceId === "MyJio") {
    return (
      <>
        {children}
        <div>
          <button
            className="buttonList marginLeft20 marginTop20"
            style={{ background: '#034ea1' }}
            onClick={() => { handleMyJioButtonClick() }}
          >
            {t('DONE')}
          </button>
        </div>
      </>
    )
  }
  else if (sourceId === "JhhWebApp") {
    return (
      <>
        {children}
        <div>
          <button
            className="buttonList marginLeft20 marginTop20"
            style={{ background: '#034ea1' }}
            onClick={JhhWebAppDoneButtonClickHandler}
          >
            {t('DONE')}
          </button>
        </div>
      </>
    )
  }
  else if (ess().isFromEss || sourceId === "emp_xp") {
    return (
      <>
        {children}
        <div>
          <button className="buttonList marginLeft20 marginTop20" style={{ background: '#034ea1' }} onClick={() => window.close()}>{t('DONE')}</button>
          {/* {showUploadCertiButton.showButton &&
            <a className="marginTop20" href={showUploadCertiButton.buttonLink}>
              <button className="buttonList marginLeft20" style={{ background: '#034ea1' }}>{t('COWIN_CERT_UPLOAD_HEADER')}</button>
            </a>
          } */}
        </div>
      </>
    )
  }
  else {
    return (<>{children}</>)
  }

}

export default ShowButton